import { render } from "./NewMobileApp.vue?vue&type=template&id=53eb84a4&ts=true"
import script from "./NewMobileApp.vue?vue&type=script&lang=ts"
export * from "./NewMobileApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__